import React from 'react';
import clsx from 'clsx';
import { FormControlLabel, Switch, Typography, withStyles, Tooltip } from "@material-ui/core";

const noop = () => { };

const styles = theme => ({
    labelWrapper: {
        width: '100%',
        display: 'flex',
    },
    label: {
        color: '#878787',
        flex: 1,
        fontSize: 12,
    },
    note: {
        color: '#A9A9A9',
        fontSize: '10px',
        textAlign: 'left'
    },
    autoSwitch: {
        marginLeft: -6
    },
    formControlLabel: {
        fontSize: 12,
        color: 'grey'
    }
})

/**
 *
 * @param {{
 *  classes: Object;
 *  hidden: boolean;
 *  labelOff: string;
 *  toggleValue: boolean;
 *  note: string;
 *  labelOn: string;
 *  labelWrapperClass: *;
 *  disabled?: boolean;
 *  labelText?: string;
 *  ToggleFct?: (checked: boolean, event: React.ChangeEvent<HTMLInputElement>) => void;
 * }} param0
 */
const ReactToggle = ({
    classes,
    disabled = false,
    hidden,
    labelOff,
    labelOn,
    labelText,
    labelWrapperClass,
    note,
    ToggleFct = noop,
    toggleValue,
    tooltipOnDisabled = null,
    isDisclaimerShown = true
}) => {
    const [open, setOpen] = React.useState(false);
    const handleClose = () => {
        setOpen(false);
    };

    const handleOpen = () => {
        if (disabled && !!tooltipOnDisabled) {
            setOpen(true);
        }
    };

    return (
        <React.Fragment>
            <Tooltip open={open} onClose={handleClose} onOpen={handleOpen} title={tooltipOnDisabled}>
                <span>
                    {labelText ?
                        <div className={clsx(classes.labelWrapper, labelWrapperClass)}>
                            <Typography className={clsx(classes.label)} >{labelText}</Typography>
                        </div>
                        : ''}
                    <FormControlLabel
                        className={clsx(classes.autoSwitch)}
                        control={<Switch
                            size="small"
                            onChange={(event, checked) => { ToggleFct(checked, event) }}
                            checked={toggleValue}
                            color="primary"
                            disabled={disabled} />
                        }
                        label={
                            <Typography className={clsx(classes.formControlLabel)}>
                                {toggleValue ? labelOn : labelOff}
                            </Typography>
                        }
                        hidden={hidden}
                     />
                </span>
            </Tooltip>
            {!hidden && isDisclaimerShown ?
                <p>
                    <small className={classes.note}>{note}</small>
                </p>
            : ''}
        </React.Fragment>
    )
};

export default withStyles(styles)(ReactToggle);